import React, { useEffect, useState } from "react";
import { Shell, Section, StatusPill } from "@/components/loomi/Layout";
import { PANEL_NAV } from "./PanelDashboard";
import { api } from "@/lib/api";

export default function PanelHistory() {
  const [history, setHistory] = useState([]);
  const [txns, setTxns] = useState([]);
  useEffect(() => {
    (async () => {
      const [h, t] = await Promise.all([api.get("/panel/history"), api.get("/panel/transactions")]);
      setHistory(h.data); setTxns(t.data);
    })();
  }, []);
  return (
    <Shell title="History" portalLabel="Panel" nav={PANEL_NAV}>
      <div className="grid md:grid-cols-2 gap-6">
        <Section title="Survey history" testId="section-panel-history">
          {history.length === 0 ? (
            <div className="text-mute text-sm py-8 text-center" data-testid="panel-history-empty">You haven&apos;t taken any surveys yet.</div>
          ) : (
            <table className="w-full text-sm" data-testid="panel-history-table">
              <thead><tr className="text-left text-xs uppercase tracking-widest text-mute border-b border-white/10">
                <th className="py-3 pr-4">Survey</th><th className="py-3 pr-4">Status</th><th className="py-3 pr-4 text-right">Points</th><th className="py-3 pr-4">Date</th>
              </tr></thead>
              <tbody>
                {history.map((h) => (
                  <tr key={h.id} className="border-b border-white/5">
                    <td className="py-3 pr-4">{h.project_name}</td>
                    <td className="py-3 pr-4"><StatusPill status={h.status} /></td>
                    <td className="py-3 pr-4 text-right font-mono status-complete">{h.status === "complete" ? h.reward_points : 0}</td>
                    <td className="py-3 pr-4 text-mute text-xs">{new Date(h.entry_time).toLocaleDateString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Section>
        <Section title="Points transactions" testId="section-panel-txns">
          {txns.length === 0 ? (
            <div className="text-mute text-sm py-8 text-center" data-testid="panel-txns-empty">No transactions yet.</div>
          ) : (
            <table className="w-full text-sm" data-testid="panel-txns-table">
              <thead><tr className="text-left text-xs uppercase tracking-widest text-mute border-b border-white/10">
                <th className="py-3 pr-4">Type</th><th className="py-3 pr-4 text-right">Points</th><th className="py-3 pr-4">Date</th>
              </tr></thead>
              <tbody>
                {txns.map((t) => (
                  <tr key={t.id} className="border-b border-white/5">
                    <td className="py-3 pr-4 uppercase text-xs tracking-widest">{t.type}</td>
                    <td className="py-3 pr-4 text-right font-mono status-complete">+{t.points}</td>
                    <td className="py-3 pr-4 text-mute text-xs">{new Date(t.created_at).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </Section>
      </div>
    </Shell>
  );
}
